import React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css'
import ReactDOM from "react-dom";
import Map from "./components/Map"
import * as Sentry from "@sentry/react";
const MIX_SENTRY_LARAVEL_DSN = process.env.MIX_SENTRY_LARAVEL_DSN;
Sentry.init({
  dsn: MIX_SENTRY_LARAVEL_DSN
});

const mapElement = document.getElementById("map");
const longitude = mapElement.getAttribute('data-longitude');
const latitude = mapElement.getAttribute('data-latitude');

ReactDOM.render(<Map longitude={longitude} latitude={latitude}/>, mapElement);